// extracted by mini-css-extract-plugin
export var csatScore = "_me-5";
export var header = "_me-1";
export var panelWrapper = "_me-2";
export var postPreview = "_me-3";
export var rightContent = "_me-0";
export var wrappingText = "_me-4";